import { generateRandomId } from "./Equation";
import { reorderFlatSecArray } from "./Leftpanel";
import { addTextFootnote } from "./tablelist";

function applyParaStyles(node, editor, list) {
  if (!editor) return;
  const dom = editor.dom;
  const nodeName = node.tagName.toLowerCase();
  const nodeParent = node.parentElement;
  let newSec;
  if (list.name.startsWith("Heading")) {
    const secLength = countSecParents(node);
    const number = getNumberFromString(list.name);
    if (
      (nodeName === "title1" || nodeName === "label") &&
      nodeParent?.tagName.toLowerCase() === "sec"
    ) {
      const nodeKey = nodeParent?.getAttribute("key");

      const sectionLength = countSecParents(nodeParent);

      if (sectionLength === number - 1)
        return { message: "Already applied", success: false };

      if (sectionLength === 0) {
        const section = nodeParent.prevElementSibling;
        if (section) {
          section.appendChild(nodeParent);
        } else {
          return { message: "Please apply correct style", success: false };
        }
      } else {
        if (sectionLength < number)
          return { message: "Please apply correct style", success: false };
        wrapSections(
          nodeParent,
          dom,
          nodeParent,
          sectionLength,
          number,
          nodeKey,
          false
        );
      }
    } else {
      if (secLength + 1 < number)
        return { message: "Please apply correct style", success: false };

      const key1 = generateRandomId("HL");
      const key2 = generateRandomId("Ht");
      const key3 = generateRandomId("SE");

      const content = node.innerText;

      const title = dom.create("title1", { key: key2 }, content);

      const label = dom.create("label", { key: key1 }, "0");
      newSec = dom.create("sec", { key: key3, id: "0" });
      newSec.appendChild(label);
      newSec.appendChild(title);
      wrapSections(node, dom, newSec, secLength, number, key3, true);
    }
    editor.undoManager.transact(() => {
      reorderFlatSecArray(editor.getBody());
    });
  }
  if (list.name == "text-foot") {
    if (nodeName === "p") {
      const notes = node.textContent;
      addTextFootnote(editor, { node }, notes);
      editor.dom.remove(node);
    } else {
      return { message: "Please select text", success: false };
    }
  }
  if (list.name === "Table-caption") {
    if (
      nodeParent.tagName.toLowerCase() === "table-wrap" &&
      nodeName === "label"
    ) {
      handleWrapTitle(editor);
    } else {
      return { message: "Please select correct text", success: false };
    }
  }
  if (list.name === "Acknowledgement") {
    if (nodeName === "p") {
      handleCreateAck(editor, node);
    } else {
      return { message: "Please select correct text", success: false };
    }
  }
  if (list.name === "fn-group") {
    if (nodeName === "p") {
      handleFnGroup(editor, node);
    } else {
      return { message: "Please select correct text", success: false };
    }
  }
  if (list.name === "fn") {
    if (nodeName === "p" && nodeParent?.parentElement.tagName.toLowerCase() === "fn-group") {
      handleFn(editor, node);
    } else {
      return { message: "Please select correct text", success: false };
    }
  }

  return { message: "Style applied", success: true };
}

function getNumberFromString(str) {
  const match = str.match(/\d+/);
  return match ? parseInt(match[0], 10) : null;
}

function handleWrapTitle(editor) {
  const selectedHtml = editor.selection.getContent({ format: "html" });

  if (!selectedHtml || !selectedHtml.trim()) {
    return;
  }

  const rng = editor.selection.getRng();
  const startContainer = rng.startContainer;
  const parentNode = startContainer.parentNode;

  if (!parentNode) return;

  const title1 = document.createElement("title1");
  title1.setAttribute("key", generateRandomId("title_"));
  title1.innerHTML = selectedHtml;

  editor.selection.setContent("");

  if (parentNode.nextSibling) {
    parentNode.parentNode.insertBefore(title1, parentNode.nextSibling);
  } else {
    parentNode.parentNode.appendChild(title1);
  }
}

const handleCreateAck = (editor, node) => {
  const key1 = generateRandomId("_ac");
  const ack = editor.dom.create("ack", { key: key1 });
  node.parentNode.insertBefore(ack, node);
  ack.appendChild(node);
  let current = ack;
  while (
    current.parentNode &&
    current.parentNode.tagName.toLowerCase() !== "back"
  ) {
    const parent = current.parentNode;
    parent.parentNode.insertBefore(current, parent.nextSibling);
  }
};
const handleFnGroup = (editor, node) => {
  const key1 = generateRandomId("_fng");
  const fngroup = editor.dom.create("fn-group", { key: key1 });
  const key2 = generateRandomId("_fn");
  const fn = editor.dom.create("fn1", { key: key2 });

  node.parentNode.insertBefore(fngroup, node);
  fngroup.appendChild(fn);
  fn.appendChild(node);
  let current = fngroup;
  while (
    current.parentNode &&
    current.parentNode.tagName.toLowerCase() !== "back"
  ) {
    const parent = current.parentNode;
    parent.parentNode.insertBefore(current, parent.nextSibling);
  }
};
const handleFn = (editor, node) => {
  const key2 = generateRandomId("_fn");
  const fn = editor.dom.create("fn1", { key: key2 });

  node.parentNode.insertBefore(fn, node);
  fn.appendChild(node);
  let current = fn;
  while (
    current.parentNode &&
    current.parentNode.tagName.toLowerCase() !== "fn-group"
  ) {
    const parent = current.parentNode;
    parent.parentNode.insertBefore(current, parent.nextSibling);
  }
};

function wrapSections(node, dom, newSec, secLength, number, key, remove) {
  let i = 0;
  let next;

  while (i <= secLength - number) {
    if (i === 0) {
      const parent = node.parentElement;
      if (!parent) return;

      const siblingsToMove = [];
      let sibling = node.nextElementSibling;
      while (sibling) {
        siblingsToMove.push(sibling);
        sibling = sibling.nextElementSibling;
      }

      siblingsToMove.forEach((el) => dom.remove(el));
      siblingsToMove.forEach((el) => dom.add(newSec, el));

      dom.insertAfter(newSec, parent);
      if (remove) {
        dom.remove(node);
      }
      next = dom.select(`sec[key="${key}"]`)[0];
    } else {
      if (!next || !next.parentElement) return;

      const parent = next.parentElement;
      const siblingsToMove = [];
      let sibling = next.nextElementSibling;
      while (sibling) {
        siblingsToMove.push(sibling);
        sibling = sibling.nextElementSibling;
      }

      siblingsToMove.forEach((el) => dom.remove(el));
      siblingsToMove.forEach((el) => dom.add(next, el));

      dom.insertAfter(next, parent);
      next = dom.select(`sec[key="${key}"]`)[0];
    }
    i++;
  }

  if (secLength - number < 0) {
    const parent = node.parentElement;
    if (!parent) return;

    const siblingsToMove = [];
    let sibling = node.nextElementSibling;

    while (sibling) {
      if (sibling.tagName?.toLowerCase() === "sec") break;
      siblingsToMove.push(sibling);
      sibling = sibling.nextElementSibling;
    }

    siblingsToMove.forEach((el) => dom.remove(el));
    siblingsToMove.forEach((el) => dom.add(newSec, el));

    dom.replace(newSec, node);
  }
}

function countSecParents(node) {
  let count = 0;
  let current = node.parentElement;

  while (current) {
    if (current.nodeName.toLowerCase() === "sec") {
      count++;
    }

    if (current.nodeName.toLowerCase() === "body1") {
      break;
    }

    current = current.parentElement;
  }

  return count;
}

export { applyParaStyles };
